import { combineReducers } from 'redux';
import Auth from './Auth';
import Theme from './Theme';
import JewelleryCoinPrice from './JewelleryCoinPrice';
import MarkupDeductPercentage from './MarkupDeductPercentage';
import Ui from './Ui';
import actionHistory from './ActionHistory';
import FeedConfig from './FeedConfig';
import FeedPrice from './FeedPrice';
import Company from './Company';

const reducers = combineReducers({
  theme: Theme,
  Ui: Ui,
  auth: Auth,
  jewelleryCoinPrice: JewelleryCoinPrice,
  markupDeductPercentage: MarkupDeductPercentage,
  actionHistory: actionHistory,
  feedConfig: FeedConfig,
  feedPrice: FeedPrice,
  company: Company,
});

export default reducers;
